var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoundwavessvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 32,
    viewBox: "0 0 66 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: 12.75,
    x2: 0.75,
    y2: 19.25,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4.75,
    y1: 8.75,
    x2: 4.75,
    y2: 23.25,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 8.75,
    y1: 0.75,
    x2: 8.75,
    y2: 31.25,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 12.75,
    y1: 4.75,
    x2: 12.75,
    y2: 27.25,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 16.75,
    y1: 8.75,
    x2: 16.75,
    y2: 23.25,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 20.75,
    y1: 8.75,
    x2: 20.75,
    y2: 23.25,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 24.75,
    y1: 12.75,
    x2: 24.75,
    y2: 19.25,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 28.75,
    y1: 7.25,
    x2: 28.75,
    y2: 24.75,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 32.75,
    y1: 14.75,
    x2: 32.75,
    y2: 17.25,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 36.75,
    y1: 8.75,
    x2: 36.75,
    y2: 23.25,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 40.75,
    y1: 8.75,
    x2: 40.75,
    y2: 23.25,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 44.75,
    y1: 12.75,
    x2: 44.75,
    y2: 19.25,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 48.75,
    y1: 8.75,
    x2: 48.75,
    y2: 23.25,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 52.75,
    y1: 4.75,
    x2: 52.75,
    y2: 27.25,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 56.75,
    y1: 0.75,
    x2: 56.75,
    y2: 31.25,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 60.75,
    y1: 8.75,
    x2: 60.75,
    y2: 23.25,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 64.75,
    y1: 12.75,
    x2: 64.75,
    y2: 19.25,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundwavessvg);
export default __webpack_public_path__ + "static/media/sound waves svg.9d115044.svg";
export { ForwardRef as ReactComponent };